<template>
  <b-overlay spinner-variant="primary" :show="isLoading">
    <b-alert
      class="d-block w-100 mt-2 py-2 px-1"
      variant="warning"
      :show="dataLoaded && !ticket.id"
    >
      Звернення не знайдено
    </b-alert>
    <div v-if="ticket && ticket.id" class="row">
      <div class="col-12">
        <b-card>
          <div class="d-flex">
            <b-badge variant="light-primary" class="mr-1">
              ID: {{ ticket.id }}
            </b-badge>
            <h4 class="card-title mb-0">{{ getType(ticket.type) }}</h4>
          </div>
        </b-card>
      </div>
      <div class="col-12 col-md-4">
        <b-card title="Створено">
          <span v-if="ticket.created_at">
            {{ ticket.created_at | moment("calendar") }}
          </span>
        </b-card>
      </div>
      <div class="col-12 col-md-4">
        <b-card title="Статус">
          <statusBadge :status="ticket.status" />
        </b-card>
      </div>
      <div class="col-12 col-md-4">
        <b-card title="Відправник">
          <span v-if="ticket.sender_info">
            <router-link
              v-if="ticket.sender_info"
              :to="{
                name: 'user-single',
                params: { id: ticket.sender_info.id },
              }"
            >
              {{ ticket.sender_info.last_name }}
              {{ ticket.sender_info.first_name }}.
            </router-link>
          </span>
          <span v-else>Аноінімно</span>
        </b-card>
      </div>
      <div class="col-12 col-md-6">
        <b-card title="Тема">
          {{ ticket.topic || "--" }}
        </b-card>
      </div>
      <div class="col-12 col-md-6">
        <b-card title="Адресовано до">
          <router-link
            :to="{
              name: 'departments-single',
              params: { id: getDepartment(ticket.department).id },
            }"
          >
            {{ getDepartment(ticket.department).name }}
          </router-link>
        </b-card>
      </div>

      <div class="col-12">
        <b-card title="Текст">{{ ticket.text }}</b-card>
      </div>
      <div class="col-12" v-if="ticket.form_data && ticket.form_data.length">
        <b-card title="Дані форми">
          <div
            v-for="(item, i) in ticket.form_data"
            :key="i"
            class="d-flex mb-50"
          >
            <strong class="mr-50">{{ item.label }}:</strong>
            <span v-if="item.type === 'checkbox'">
              {{ item.value ? 'Так' : 'Ні' }}
            </span>
            <span v-else-if="item.type === 'file' && item.value && item.value.file_url">
              <a :href="item.value.file_url" target="_blank">
                {{ item.value.file_name || 'Відкрити файл' }}
              </a>
            </span>
            <span v-else>{{ item.value || '—' }}</span>
          </div>
        </b-card>
      </div>
      <div class="col-12">
        <b-card title="Файли">
          <div v-for="f in ticket.files" :key="f.id">
            <a :href="f.file_url" target="_blank">
              {{ f.orig_path }}
            </a>
          </div>
          <b-alert
            class="p-1"
            :variant="'secondary'"
            show
            v-if="!ticket.files || !ticket.files.length"
          >
            Файлів немає
          </b-alert>
        </b-card>
      </div>
      <div class="col-12">
        <b-card title="Дії із запитом">
          <b-tabs content-class="mt-1">
            <b-tab title="Відповідь" active>
              <b-alert show variant="primary py-1 px-2">
                <h5>Надішліть офіційну відповідь на запит.</h5>
                За замовчуванням запит, отримає новий статус
                <strong>"Виконано"</strong>, проте, перед надсиланням відпоіді,
                його можна змінити
              </b-alert>
              <b-form-textarea
                id="response"
                v-model="ticket_event.response_text"
                placeholder="Текст офіційної відповіді"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <div class="text-left">
                <textLength
                  :text="ticket_event.response_text"
                  :limit="text_limit"
                />
              </div>
              <div class="file">
                <fileUploader @update="setFiles" />
              </div>
              <div class="d-flex mt-1 justify-content-end">
                <div class="mr-auto">
                  <div class="confirm mr-auto">
                    <label
                      for="confirmation-response"
                      class="d-flex align-items-center"
                    >
                      <b-form-checkbox
                        id="confirmation-response"
                        name="confirmation-response"
                        v-model="confirmation.response"
                      ></b-form-checkbox>
                      Відповідь перевірена
                    </label>
                  </div>
                  <div
                    class="confirm mr-auto"
                    v-if="ticket_event.next_status == 1"
                  >
                    <label for="make-public" class="d-flex align-items-center">
                      <b-form-checkbox
                        id="make-public"
                        name="make-public"
                        v-model="ticket_event.make_public"
                      ></b-form-checkbox>
                      Зробити відповідь публічною
                    </label>
                  </div>
                  <div class="confirm mr-auto" v-if="ticket_event.make_public">
                    <label
                      for="make-author-public"
                      class="d-flex align-items-center"
                    >
                      <b-form-checkbox
                        id="make-author-public"
                        name="make-author-public"
                        v-model="ticket_event.make_author_public"
                      ></b-form-checkbox>
                      Показати автора запиту публічно
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <strong class="ml-auto mr-1">Наступний статус:</strong>
                <b-form-select
                  style="width: 200px"
                  v-model="ticket_event.next_status"
                  :options="statusOptions"
                  class="mr-2"
                >
                </b-form-select>
                <b-button
                  variant="primary"
                  :disabled="disableResponse == true"
                  @click="sendResponse"
                  >Надіслати відповідь</b-button
                >
              </div>
            </b-tab>
            <b-tab title="Переадресація запиту">
              <b-alert show variant="primary py-1 px-2">
                У разі невідповідності запиту до Вашого відділу, можна
                перенаправити запит на більш відповідний підрозділ.
                Перенаправивши запит на інший відділ, Ви втратите до нього
                доступ. Запит отримає новий статуc:
                <strong> "Переадресовано"</strong>
              </b-alert>

              <v-select
                id="department-parent"
                v-model="ticket_event.next_department"
                :options="departmentsOPtions"
                :reduce="(text) => text.value"
                label="text"
                placeholder="Оберіть відділ, на який потрібно переадресвати запит"
              />
              <b-form-textarea
                id="redirect"
                v-model="ticket_event.response_text"
                placeholder="Коментар до переадресації"
                class="mt-2"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <div class="text-left">
                <textLength
                  :text="ticket_event.response_text"
                  :limit="text_limit"
                />
              </div>
              <div class="d-flex align-items-center mt-1 justify-content-end">
                <div class="confirm mr-auto">
                  <label
                    for="confirmation-redirect"
                    class="d-flex align-items-center"
                  >
                    <b-form-checkbox
                      id="confirmation-redirect"
                      name="confirmation-redirect"
                      v-model="confirmation.redirect"
                    ></b-form-checkbox>
                    Переадресація перевірена
                  </label>
                </div>
                <b-button
                  :disabled="disableRedirectcion"
                  variant="primary"
                  @click="makeRedirection"
                  >Переадресувати запит</b-button
                >
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
      <div class="col-12">
        <b-card title="Історія">
          <b-overlay :show="historyLoading">
            <history-item
              v-for="event in events"
              :event="event"
              :key="event.uid"
            />
          </b-overlay>
        </b-card>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import statusBadge from "@/components/ticket-status-badge";
import vSelect from "vue-select";
import textLength from "@/components/text-length.vue";
import fileUploader from "@/components/file-uploader.vue";
import historyItem from "@/components/ticket-history-item.vue";
export default {
  components: {
    statusBadge,
    vSelect,
    textLength,
    fileUploader,
    historyItem,
  },
  data() {
    return {
      confirmation: {
        response: false,
        redirect: false,
      },
      text_limit: 1400,
      isLoading: false,
      dataLoaded: false,
      historyLoading: false,
      ticket: {},
      events: [],
      sender: null,
      ticket_event: {
        approved: false,
        prev_status: 0,
        is_redirection: false,
        response_text: "",
        next_department: null,
        next_status: 1,
        make_public: false,
        make_author_public: false,
        user: "",
        created_at: "",
        sender: "",
        seen: false,
        id: null,
        ticket_type: "",
        files: [],
      },
    };
  },
  computed: {
    departmentsOPtions() {
      var list = this.departments.map((e) => {
        return { text: e.name, value: e.id };
      });

      //Not allow to be parent of self
      return list.filter((e) => e.value != this.ticket.department);
    },
    ...mapGetters({
      datasets: "getDatasets",
      user: "getUser",
    }),
    statusOptions() {
      var options = this.statuses.map((e) => {
        return { value: e.id, text: e.name };
      });
      return options.filter((e) => e.value !== 0 && e.value !== 3);
    },
    statuses() {
      return this.datasets.statuses;
    },
    ticket_types() {
      return this.datasets.ticket_types;
    },
    departments() {
      return this.datasets.departments;
    },
    disableResponse() {
      let disabled = false;
      if (
        this.confirmation.response == false ||
        this.ticket_event.response_text.length < 1 ||
        this.text_limit < this.ticket_event.response_text.length
      ) {
        disabled = true;
      }
      return disabled;
    },
    disableRedirectcion() {
      let disabled = false;
      if (
        this.confirmation.redirect == false ||
        this.ticket_event.response_text.length < 16 ||
        this.text_limit < this.ticket_event.response_text.length
      ) {
        disabled = true;
      }
      return disabled;
    },
  },
  methods: {
    setFiles(data) {
      this.ticket_event.files = data;
    },
    async getTicket() {
      this.isLoading = true;
      let id = Number(this.$route.params.id);
      let response = await this.$api.get("/admin/tickets/" + id);
      if (response.data.data) {
        let ticket = response.data.data;
        ticket.files = ticket.files.filter((e) => e != null);
        this.ticket = ticket;

        this.getTicketHistory();
      }
      if (this.ticket.sender) {
        this.getUser();
      }
      this.dataLoaded = true;
      this.isLoading = false;
    },
    async getUser() {
      var response = await this.$api.get(
        "/admin/users/byUid/" + this.ticket.sender,
      );
      this.sender = response.data.data;
    },
    getStatus(id) {
      let name = "";
      let status = this.statuses.find((el) => el.id == id);
      if (status) {
        name = status.name;
      }
      return name;
    },
    getType(slug) {
      var name = "";
      let type = this.ticket_types.find((el) => el.slug == slug);
      if (type) {
        name = type.nane;
      }
      return name;
    },
    getDepartment(id) {
      if (this.departments) {
        return this.departments.find((el) => el.id == id) || {};
      }
      return {};
    },
    async sendResponse() {
      this.isLoading = true;
      try {
        var payload = {
          ticket_uid: this.ticket.uid,
          response_text: this.ticket_event.response_text,
          next_status: this.ticket_event.next_status,
          make_public: this.ticket_event.make_public,
          make_author_public: this.ticket_event.make_author_public,
          is_redirection: false,
          next_department: null,
          files: this.ticket_event.files,
          ticket_id: this.ticket.id,
          user: this.ticket.sender,
          sender: this.user.uid,
          prev_status: this.ticket.status,
        };
        var result = await this.$api.post("/admin/tickets/respond", payload);
        if (result.data.success) {
          this.$toast.success("Відповідь надіслано");
          this.$router.push("/tickets/all");
        } else {
          this.$toast.error("Сталася помилка");
        }
      } catch (e) {
        this.$toast.error("Сталася помилка");
      }
      this.isLoading = false;
    },

    async makeRedirection() {
      this.isLoading = true;
      try {
        var payload = {
          ticket_uid: this.ticket.uid,
          response_text: this.ticket_event.response_text,
          next_status: 3,
          make_public: false,
          make_author_public: false,
          is_redirection: true,
          next_department: this.ticket_event.next_department,
          files: this.ticket_event.files,
          ticket_id: this.ticket.id,
          user: this.ticket.sender,
          sender: this.user.uid,
          prev_status: this.ticket.status,
        };
        var result = await this.$api.post("/admin/tickets/respond", payload);
        if (result.data.success) {
          this.$toast.success("Запит переадресовано");
          this.$router.push("/tickets/all");
        } else {
          this.$toast.error("Сталася помилка");
        }
      } catch (e) {
        this.$toast.error("Сталася помилка");
      }
      this.isLoading = false;
    },
    async getTicketHistory() {
      if (!this.ticket.id) return;
      this.historyLoading = true;
      var response = await this.$api.get(
        "/admin/tickets/" + this.ticket.id + "/history",
      );
      this.events = response.data.data;
      this.historyLoading = false;
    },
  },
  mounted() {
    this.getTicket();
  },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-select.scss";
</style>
